// Pure, unit-tested display helpers for drip sequences (mirrors business
// Sequence* constants). Kept separate from the React components so they're
// testable without rendering.

export function sequenceStatusMeta(status) {
  switch (status) {
    case "active":
      return { label: "Active", color: "green" };
    case "paused":
      return { label: "Paused", color: "gold" };
    case "draft":
    default:
      return { label: "Draft", color: "gray" };
  }
}

export function sequenceTriggerLabel(trigger) {
  switch (trigger) {
    case "list_join":
      return "When a contact joins the list";
    case "manual":
    default:
      return "Manual enrollment";
  }
}

// Human-friendly wait label for a step's delay_minutes.
export function formatDelay(minutes) {
  const m = Number(minutes) || 0;
  if (m <= 0) {
    return "Immediately";
  }
  if (m < 60) {
    return `${m} min`;
  }
  if (m < 60 * 24) {
    const hrs = m / 60;
    return `${round1(hrs)} hr`;
  }
  const days = m / (60 * 24);
  return `${round1(days)} day${days === 1 ? "" : "s"}`;
}

function round1(n) {
  return Math.round(n * 10) / 10;
}
